import { render, staticRenderFns } from "./vehicleStatistics.vue?vue&type=template&id=c33519ac&scoped=true"
import script from "./vehicleStatistics.vue?vue&type=script&lang=js"
export * from "./vehicleStatistics.vue?vue&type=script&lang=js"
import style0 from "./vehicleStatistics.vue?vue&type=style&index=0&id=c33519ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33519ac",
  null
  
)

export default component.exports